import React, { useContext } from "react";
import { CcRootContext } from "../../conversionCenterRoot";
import CcList from "../ccList";
import CcLinkButton from "../ccLinkButton";
import { getArrayLastItem } from "../../helpers/helpers";

export const Contact = ({ defaultScreen = null, items }) => {
  const ctx = useContext(CcRootContext);
  const current = defaultScreen ||  getArrayLastItem(ctx.history);

  return(
    <CcList>
      {
        Object.entries(items).filter(([_k,v]) => v.active).map(([key, itemData]) => (
          <CcLinkButton
            key={key}
            data={{
              btnData: {
                buttonTitle: itemData.title,
                numberInOrder: key,
              },
              speciality: current.activeSpecialty,
              contentType: "contactScreen",
              id: current.viewId,
            }}
          />
        ))
      }
    </CcList>
  );
};
